<template>
    <template v-if="data.valueOptions.length === 1">
        <div class="single-toggle">
            <template v-if="data.checkboxmode == 'normal'">
                <Checkbox
                    :inputId="`${step.name}[${data.element_details.name}]` + '-' + data.valueOptions[0].value"
                    :name="`${step.name}[${data.element_details.name}]`"
                    v-model="field.value"
                    :value="data.valueOptions[0].value"
                    @change="onInput"
                />
            </template>
            <template v-else>
                <ToggleSwitch
                    :inputId="`${step.name}[${data.element_details.name}]` + '-' + data.valueOptions[0].value"
                    :name="`${step.name}[${data.element_details.name}]`"
                    :trueValue="data.valueOptions[0].value"
                    :falseValue="[]"
                    v-model="field.value"
                    @update:modelValue="onToggle"
                />
            </template>
            <label :for="`${step.name}[${data.element_details.name}]` + '-' + data.valueOptions[0].value">
                {{ data.valueOptions[0].label }}
            </label>
        </div>
    </template>
    <template v-else>
        <CheckboxGroup
            :name="`${step.name}[${data.element_details.name}]`"
            class="multiCheckbox--group"
            :unstyled="true"
            v-model="field.value"
            @update:modelValue="onGroupChange"
        >   
            <div class="multiCheckbox" v-for="(option, index) in data.valueOptions" :key="option.value">
                <Checkbox
                    :inputId="`${step.name}[${data.element_details.name}]` + '-' + option.value"
                    :value="option.value"
                />
                <label :for="`${step.name}[${data.element_details.name}]` + '-' + option.value">
                    <span v-html="option.label"></span>
                </label>
            </div>
        </CheckboxGroup>
    </template>
</template>

<script setup>
import { computed } from 'vue';

const emit = defineEmits(['update:slideForward','change']);

const props = defineProps({
    data: Object,
    field: Object,
    step: Object,
});


function onInput() {
    emit('change')
    if (!!props.data.jump) {
        emit('update:slideForward');
    }
}


// const isChecked = computed(() => {
//     const val = props.data.valueOptions[0].value;
//     return Array.isArray(props.modelValue) && props.modelValue.includes(val);
// });

// function onToggle(checked) {
//     const val = props.data.valueOptions[0].value;
//     const arr = Array.isArray(checked) == false ? [val] : [];

//     // console.log('onToggle', arr, checked);
    
//     emit('update:modelValue', arr);
//     if (!!props.data.jump) {
//         emit('update:slideForward');
//     }
// }

// function onGroupChange(val) {
//     emit('update:modelValue', val);
//     if (!!props.data.jump) {
//         emit('update:slideForward');
//     }
// }
</script>